export default {
  xpb: {
    confirm: {
      title: '提示',
      // 后期确认是否通过变量处理
      content: '你确认操作嘛 ?'
    },
    btn: {
      add: '添加',
      restore: '默认',
      confirm: '确认',
      save: '保存',
      cancel: '取消',
      reset: '重置'
      // clear: '清空'
    },
    selectAll: '全选',
    noData: '暂无数据',
    refresh: '刷新',
    copy: '复制',
    column: '视图',
    // 筛选相关
    filter: {
      filterLabel: '筛选器',
      collapseAll: '折叠全部',
      expandAll: '展开全部',
      filtersSettingTips: '您可自定义常驻筛选器，拖动可调整顺序，至多{num}项',
      arrangeFilters: '排列过滤',
      availableFilters: '可用筛选项',
      filterSelected: '已选',
      clearAllFilters: '清除过滤条件',
      saveFilter: '保存过滤条件',
      clearAll: '清空所有条件并保存',
      startDate: '开始日期',
      endDate: '结束日期',
      selectDate: '选择日期'
      // // SelectAll: '选择全部',
      // // minimumAmount: '最小金额',
      // // maximumAmount: '最大金额',
      // // minimumNumber: '最小值',
      // // maximumNumber: '最大值',
      // // searchBy: '输入',
      // // pleaseSelect: '请选择',
      // // lastWeek: '近一周',
      // // lastMonth: '近一个月',
      // // last3Month: '近三个月',
      // // clearFilter: '清空过滤条件',
      // // commitFilter: '提交',
      // // selected: '已勾选',
      // // searchResult: '搜索结果',
      // // noResult: '暂无数据',
      // // filtersTabInputPlaceholder: '输入标签名',
      // saveAs: '另存为',
      //
      // // filters: '筛选器',
      // saveView: '保存',
      // // selectAll: '全选',
      // range: '选择区间',
      // d: '天',
      // h: '小时',
      // '0-1d': '0-1天',
      // '1-3d': '1-3天'
      // // filterOrder: '已选'
    },
    columnsPop: {
      title: '选择需要在列表展示的列',
      selected: '已选',
      options: '选项'
    },
    ant: {
      input: {
        placeholder: '请输入',
        search: '请搜索'
      }
    },
    table: {
      action: '操作',
      hasChecked: '项已选'
    },
    validate: {
      validateEmptyTips: '{name}不能为空',
      validateEnterTips: '请填写{name}',
      validateFailure: '{name}校验失败',
      validateInvalid: '{name}无效',
      pleaseSelect: '请选择{name}',
      validateRequired: '{name}必填',
      validateLength: '{name}长度在{min}-{max}个字符之间',
      pleaseCheckFormat: '请检查{name}格式',
      validateAlreadyExists: '{name}已存在'
    },
    message: {
      addSuccess: '添加成功',
      editSuccess: '编辑成功',
      CopiedSuccessfully: '复制成功!',
      CopyFailure: '复制失败'
    }
  }
}
